import { render } from "./acccount-opening-config-modal.vue?vue&type=template&id=a0d3618e"
import script from "./acccount-opening-config-modal.vue?vue&type=script&lang=js"
export * from "./acccount-opening-config-modal.vue?vue&type=script&lang=js"

import "./acccount-opening-config-modal.vue?vue&type=style&index=0&id=a0d3618e&lang=css"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__